import React, { useState } from 'react'
import styled from 'styled-components'
import { getInitials, getAvatarColor } from 'utils/user'

const Avatar = ({ src, firstName, lastName, email, size = 40, className }) => {
  const [failedSrc, setFailedSrc] = useState(null)
  const hasImage = src && failedSrc !== src

  if (hasImage) {
    return (
      <Img
        src={src}
        alt=''
        $size={size}
        className={className}
        referrerPolicy='no-referrer'
        onError={() => setFailedSrc(src)}
      />
    )
  }

  return (
    <Fallback
      $size={size}
      $bg={getAvatarColor(email || `${firstName || ''}${lastName || ''}`)}
      className={className}
      aria-hidden='true'
    >
      {getInitials(firstName, lastName, email)}
    </Fallback>
  )
}

export default Avatar

const Img = styled.img`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
  display: block;
`

const Fallback = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: #fff;
  font-weight: 700;
  font-size: ${({ $size }) => Math.round($size * 0.4)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  flex: 0 0 auto;
  user-select: none;
`
